import { render, staticRenderFns } from "./saveddataform.vue?vue&type=template&id=66f9eff6&scoped=true"
import script from "./saveddataform.vue?vue&type=script&lang=js"
export * from "./saveddataform.vue?vue&type=script&lang=js"
import style0 from "./saveddataform.vue?vue&type=style&index=0&id=66f9eff6&prod&lang=css"
import style1 from "./saveddataform.vue?vue&type=style&index=1&id=66f9eff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f9eff6",
  null
  
)

export default component.exports